import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=35c682b4&scoped=true"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"
import style0 from "./Chapter.vue?vue&type=style&index=0&id=35c682b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c682b4",
  null
  
)

export default component.exports